// Sprachcode fuer Web Speech (Vorlesen/Diktieren) aus der UI-Sprache (i18n-Code "de"/"en").
export const toSpeechLang = (uiLanguage: string | undefined): string =>
    (uiLanguage ?? 'en').startsWith('de') ? 'de-DE' : 'en-US';

const GERMAN_HINTS = /\b(und|nicht|ist|der|die|das|ein|eine|mit|fuer|für|auch|sich|werden|kann|oder|wenn)\b|[äöüß]/gi;
const ENGLISH_HINTS = /\b(the|and|is|are|not|with|for|this|that|you|can|will|have|from|what)\b/gi;

// Grobe Heuristik fuer die Sprache einer einzelnen Nachricht (Antworten folgen nicht zwingend der
// UI-Sprache). Bei Gleichstand/zu wenig Text gewinnt die UI-Sprache.
export const detectSpeechLang = (text: string, fallback: string): string => {
    const german = text.match(GERMAN_HINTS)?.length ?? 0;
    const english = text.match(ENGLISH_HINTS)?.length ?? 0;
    if (german + english < 3 || german === english) return fallback;
    return german > english ? 'de-DE' : 'en-US';
};
